import * as bowser from 'bowser';
import { analytics } from 'react-shisell';
import { UserBrowser, identity, enrichAnalyticsWithUser } from '@soluto-home-web/platform-core';
import OriginIdentifier from './originIdentifier';
import { AnalyticsEventModel } from 'shisell';
import * as analyticsWritersObject from './analyticsWriters';
import { IAnalyticsWriter } from './analyticsWriters/IAnalyticsWriter';
import { initialize as initializeGeoLocation } from './geo-location-api';
import { logger } from '@soluto-home-web/platform-utils';
import { getPartner } from '@soluto-home-web/smart-home-support/partner';
const meta = require('../../build-tools/public/meta.json');

let _writers: IAnalyticsWriter[] | null = null;

const getEnabledWriters = async (): Promise<IAnalyticsWriter[]> => {
  const analyticWriters: IAnalyticsWriter[] = Object.keys(analyticsWritersObject)
    .map((key) => analyticsWritersObject[key])
    .filter((writer) => writer.write && writer.isEnabled);

  const enabledWritersPromise: Promise<boolean>[] = analyticWriters.map((writer) => writer.isEnabled());

  const enabledWriters = await Promise.all(enabledWritersPromise);
  return analyticWriters.filter((_, index) => enabledWriters[index]);
};

const writer = async (eventModel: AnalyticsEventModel) => {
  if (_writers == null) _writers = await getEnabledWriters();
  await Promise.all(_writers.map((writer) => writer.write(eventModel)));
};

export const initAnalytics = () => {
  analytics.setWriter(writer);
  const userBrowserId = UserBrowser.Id;

  analytics.transformDispatcher((dispatcher) => {
    const { partnerName } = getPartner();
    dispatcher = dispatcher
      .withFilter((model) => {
        model.ExtraData.Url = window.location.href.split('?')[0];
      })
      .withIdentity('UserBrowserId', userBrowserId)
      .withMeta('IsTest', globals.REACT_APP_IS_TEST)
      .withExtra('IsTest', globals.REACT_APP_IS_TEST)
      .withExtra('AppName', 'SmartHomeSupportWeb')
      .withExtra('OsType', (bowser as any).osname)
      .withExtra('OsVersion', bowser.osversion)
      .withExtra('BrowserType', bowser.name)
      .withExtra('BrowserVersion', bowser.version)
      .withExtra('ScreenWidth', window.screen.width)
      .withExtra('ScreenHeight', window.screen.height)
      .withExtra('CurrentOrigin', OriginIdentifier.origin.current)
      .withExtra('InitialOrigin', OriginIdentifier.origin.inital)
      .withExtra('EnvironmentPartner', globals.REACT_APP_PARTNER)
      .withExtra('CarrierName', partnerName)
      .withExtra('MessagingPartner', partnerName)
      .withExtra('IsIdentified', identity.isLoggedIn())
      .withExtra('DeviceFormFactor', (bowser.tablet && 'Tablet') || (bowser.mobile && 'Mobile') || 'Desktop')
      .withExtra('WebsiteVersion', meta.version);

    dispatcher = enrichAnalyticsWithUser(dispatcher, identity.get());
    return dispatcher;
  });

  identity.updated$.subscribe((user) => {
    analytics.transformDispatcher((d) => enrichAnalyticsWithUser(d, user));
  });

  initializeGeoLocation()
    .then((geoLocation) => {
      analytics.transformDispatcher((dispatcher) =>
        dispatcher
          .withExtra('CountryId', geoLocation.CountryId)
          .withExtra('CityName', geoLocation.CityName)
          .withExtra('CountryName', geoLocation.CountryName)
          .withExtra('Region', geoLocation.Region)
      );
    })
    .catch((err) => {
      logger.warn('failed to init geolocation', err);
    });
};



// WEBPACK FOOTER //
// ./packages/web-app/src/services/analyticsInitializer.ts